import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Card, { /* CardActions, */ CardContent } from 'material-ui/Card';
// import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';

const styles = theme => ({
  card: {
    minWidth: 225,
    maxWidth: '98%',
    marginLeft: '1%',
    textAlign: 'justify',
    marginTop: 16,
    marginBottom: 16,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    marginBottom: 16,
    fontSize: 14,
    color: theme.palette.text.secondary,
  },
  headline: {
    marginBottom: 16,
    color: theme.palette.text.primary,
    textAlign: 'center',
  },
  pos: {
    marginBottom: 12,
    color: theme.palette.text.secondary,
  },
});

function SimpleCard(props) {
  const { classes } = props;
  // const bull = <span className={classes.bullet}>•</span>;

  return (
    <div>
      <Card className={classes.card}>
        <CardContent>
          <Typography className={classes.title}>{props.title}</Typography>
          <Typography className={classes.headline} type="headline" component="h2">{props.headline}</Typography>
          {/* <Typography className={classes.pos}>adjective</Typography> */}
          {props.content}
        </CardContent>
        {/* <CardActions>
          <Button dense>Learn More</Button>
        </CardActions> */}
      </Card>
    </div>
  );
}

SimpleCard.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string,
  headline: PropTypes.string.isRequired,
  content: PropTypes.element.isRequired,
};

export default withStyles(styles)(SimpleCard);


// WEBPACK FOOTER //
// ./src/components/SimpleCard.jsx